import { CreateStatusPageDTO, UpdateStatusPageDTO } from '@meshwatch/types';
import * as Yup from 'yup';

import { userIdSchema, uuidIdSchema } from '../../shared/validation/schemas';

const CREATE_STATUS_PAGE_SCHEMA_SHAPE = {
  userId: userIdSchema,
  niceName: Yup.string().required('niceName is required'),
  includeAllMonitors: Yup.boolean().required('includeAllMonitors is required'),
  monitors: Yup.array().of(Yup.string()),
  customDomain: Yup.string(),
  logo: Yup.string(),
};

export const CREATE_STATUS_PAGE_SCHEMA = Yup.object().shape<CreateStatusPageDTO>(
  CREATE_STATUS_PAGE_SCHEMA_SHAPE
);

const UPDATE_STATUS_PAGE_SCHEMA_SHAPE = {
  ...CREATE_STATUS_PAGE_SCHEMA_SHAPE,
  id: uuidIdSchema,
};

export const UPDATE_STATUS_PAGE_SCHEMA = Yup.object().shape<UpdateStatusPageDTO>(
  UPDATE_STATUS_PAGE_SCHEMA_SHAPE
);
